import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageService } from "src/app/core/helpers/storage-Service";
import { FinalTxnStatus } from "../../models/transaction.status";
import { urlRedirector } from "src/app/core/constants/constants";
import { WhiteLabelInfo } from "src/app/core/models/model";

@Component({
  selector: "app-final-transaction-status",
  templateUrl: "./final-transaction-status.component.html",
  styleUrls: ["./final-transaction-status.component.css"],
  standalone: false,
})
export class FinalTransactionStatusComponent implements OnInit, OnDestroy {
  isCallBackUrl: boolean;
  grouped: string;
  txnStatus = new FinalTxnStatus();

  storeName: string;
  whiteLabelInfo: WhiteLabelInfo;

  customerName: string;
  status: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    if (
      localStorage.getItem("ussd") !== null &&
      sessionStorage.getItem("bankCode") !== null
    ) {
      sessionStorage.removeItem("ussd");
      sessionStorage.removeItem("bankCode");
    }
    if (this.route.snapshot.params["statusObj"]) {
      this.txnStatus =
        JSON.parse(atob(this.route.snapshot.params["statusObj"])) ||
        this.route.snapshot.params["status"];

      if (this.txnStatus.callbackUrl?.startsWith("short.ly/")) {
        this.txnStatus.callbackUrl = urlRedirector(this.txnStatus.callbackUrl);
      }
      if (this.txnStatus.redirectUrl?.startsWith("short.ly/")) {
        this.txnStatus.redirectUrl = urlRedirector(this.txnStatus.redirectUrl);
      }
      this.customerName = this.storageService.getCustomerName();
      this.whiteLabelInfo = this.storageService.getWhiteLableInfo();

      const { storeName } = this.storageService.getClientDetails();
      this.storeName = storeName;
      this.checkCallBack();
    } else {
      this.txnStatus.status = "completed";
    }

    // this.currency= JSON.parse(sessionStorage.getItem('paymentDetails'))['currency'] || 'NGN';
    sessionStorage.removeItem("paymentDetails");
    // this.storageService.clearStorage();

    // Check if this is the first visit
    const hasVisitedStatus = sessionStorage.getItem("hasVisitedStatus");
    if (!hasVisitedStatus) {
      setTimeout(() => {
        sessionStorage.setItem("hasVisitedStatus", "true");
        // this.router.navigate(["/rating"]);
      }, 6000);
    }
  }

  checkCallBack() {
    const url = this.txnStatus.redirectUrl || this.txnStatus.callbackUrl;

    if (
      !url ||
      url === "empty" ||
      url === "undefined" ||
      url === "www.pgs.com"
    ) {
      this.isCallBackUrl = false;
      return;
    }

    if (
      url.includes(
        "/api/accelerex-integrator/v1/callbacks/clients/wallets/fund",
      )
    ) {
      this.isCallBackUrl = false;
    } else {
      this.isCallBackUrl = true;
      setTimeout(() => {
        this.redirectUser(url);
      }, 3000);
    }
  }

  redirectUser(url: string) {
    window.location.assign(url);
  }

  ngOnDestroy(): void {
    this.storageService.removeCustomerNameAndWhiteLabelInfo();
    this.storageService.removePaymentInfo();
  }
}
